import { render } from "./FrmManageItemLocationHome.vue?vue&type=template&id=4a7cf0ff"
import script from "./FrmManageItemLocationHome.vue?vue&type=script&lang=js"
export * from "./FrmManageItemLocationHome.vue?vue&type=script&lang=js"

import "./FrmManageItemLocationHome.vue?vue&type=style&index=0&id=4a7cf0ff&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__